import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getAuth, getUser, isLoggedIn, saveCommonData } from "../utils/auth_utils";
import { NavbarTop } from "../common_components/navbar_top";
import { homeUrl } from "../utils/common_utils";
import { getJsonDataPostRequest } from "../utils/network_utils";
import LoginModal from "../login/email_login_modal";
import { MSG_ERROR_PROGRESS_UI } from "../common_components/common_ui_components";

const ViewInterviewEvaluation = () => {
  const user=getUser()
  const { interviewId} = useParams();
  const userLoggedIn=isLoggedIn()
  const [showProgress, setShowProgress]=useState(false)
  const [message, setMessage]=useState("")
  const[error, setError]=useState("")
  const[interview, setInterview]=useState(null)
  const[evaluation, setEvaluation]=useState("")

  useEffect(() => {
    console.log("loading interview details..")
    let data={
      auth:getAuth(),
      interviewId: interviewId
    }
    getJsonDataPostRequest(
      homeUrl()+"interviewApi/getLLDInterviewDetails", 
      data, function(response){
      setShowProgress(false)
      if(response==null||response.status>=400){
          setError(response.message || "Some error occured, please try again") 
          return    
      }
      if(!response.interview){
        setMessage(" Interview Details Not Found")
      }
      setInterview(response.interview)
      setEvaluation(response.finalEvaluation)
      saveCommonData(response)
  })
}, []); // empty bracket means there are no dependencies which will make useEffect re run

 return (
   <div>
   {/* below is the actual UI that user will see on laptop/desktop or any other wide screen */}
   <div className=" flex flex-col h-full w-full
     items-center justify-center ">
     <NavbarTop />
     <div className="mt-20 p-4"></div>
    {
      !userLoggedIn && 
      <div className="text-center text-xl font-mono">
        <br /> <br /> <br /> <br />
        Please Login to view Past Interview Data
        <br /><br />
        <LoginModal />
        </div>
    }
    
    {userLoggedIn &&
    <div className="flex flex-col items-center justify-center w-full">
    <div className="text-2xl  ">Interview 
      <span className="text-teal-600 px-4 font-bold">#{interviewId}</span> 
      </div>
      
      {interview && interview.questionHeading &&
      <div className="text-gray-800  mt-2">
        {interview.questionHeading}</div>
      }
      <div className="mb-8"></div>
    {
    <MSG_ERROR_PROGRESS_UI message={message} 
    error={error} showProgress={showProgress}/>
    }
   <br />
   {
      evaluation && evaluation.length>0 &&
     <div className="text-2xl text-center text-teal-700 font-mono ">
       Below is Your Final Assessment</div>
   }
   <br /><br />
    {
      evaluation && evaluation.length>0 &&
      <div className="text-gray-900 prose px-8 w-3/5 leading-8" 
      dangerouslySetInnerHTML={{ __html: evaluation }}>
      </div>
      
    }
  {
      interview && interview.interviewId>0 && (!evaluation || evaluation.length==0) &&
      <div className=" text-center text-gray-700 leading-8">
        Evaluation is Not Available for his Interview Session <br />
        Please contact: <span className="text-xl px-4 text-teal-600 font-mono">
          contact@codezym.com</span>
      </div>
    }
   </div>
   } 
    {!error && !message && !interview &&
    <div className="text-2xl font-bold text-teal-600 mt-20">
      Loading Interview Details. <br /> Please wait ...
    </div>
    }
    <br /> <br /> <br /> <br /> 
    
     </div>
     </div>
 )
}

export {ViewInterviewEvaluation}